import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { reduxForm, Field, formValueSelector } from 'redux-form'
import labelAndInput from '../common/form/labelAndInput'
import textArea from '../common/form/textArea'
import If from '../common/operador/if'
import Select from '../common/form/select'
import { createNumberMask, createTextMask } from 'redux-form-input-masks';

import { init } from './boletoAction'



const currencyMask = createNumberMask({
    prefix: '',
    suffix: '',
    decimalPlaces: 2,
    locale: 'pt-br',
})



class BoletoForm extends Component {

    getListaTipoDesconto = () => {
        let lista = []
        lista.push({ chave: 0, valor: "Sem Desconto" });
        lista.push({ chave: 1, valor: "Valor Fixo" });
        lista.push({ chave: 2, valor: "Percentual" });
        //  lista.push({ chave: 3, valor: "Dias Antecipação" });
        return lista;
    }

    getListaTipoJuro = () => {
        let lista = []
        lista.push({ chave: 0, valor: "Sem Juros" });
        lista.push({ chave: 1, valor: "Valor Dia Atraso" });
        lista.push({ chave: 2, valor: "Taxa Mensal" });
        //lista.push({ chave: 3, valor: "Dias Antecipação" });
        return lista;
    }
    
    getListaTipoMulta = () => {
        let lista = []
        lista.push({ chave: 0, valor: "Sem Multa" });
        lista.push({ chave: 1, valor: "Valor Multa" });
        lista.push({ chave: 2, valor: "Percentual" });
        //lista.push({ chave: 3, valor: "Dias Antecipação" });
        return lista;
    }
    
    


    render() {
        var { handleSubmit, readOnly, usuario_cancelamento, usuario_cadsatro } = this.props

        const formatData = (value) => {
            let dateTime = value.split(' ')
            let dtSplit = dateTime[0].split('-')
            return `${dtSplit[2]}/${dtSplit[1]}/${dtSplit[0]} ${dateTime[1]}`
        }

        const formatData2 = (value) => {
            let dateTime = value.split(' ')
            let dtSplit = dateTime[0].split('-')
            return `${dtSplit[0]}-${dtSplit[1]}-${dtSplit[2]}`
        }

        const currencyFormatter = (value) => {
            if (value === undefined) value = 0
            var valor = value;

            valor = valor + '';
            valor = parseInt(valor.replace(/[\D]+/g, ''));
            valor = valor + '';
            valor = valor.replace(/([0-9]{2})$/g, ",$1");

            if (valor.length > 6) {
                valor = valor.replace(/([0-9]{3}).([0-9]{2}$)/g, ".$1,$2");
            }

            return valor
        }

        return (
            <div>

                <form role='form' onSubmit={handleSubmit}>

                    <div className="box-body">


                        <Field name='id' component={labelAndInput}
                            label='Id'
                            cols='12 2'
                            placeholder='Id'
                            readOnly={true} />



                        <Field name='carne_id' component={labelAndInput}
                            label='Cod. Carnê'
                            cols='12 2'
                            readOnly={true} />

                        <Field name='dt_cadastro' component={labelAndInput}
                            type='text' cols='12 3'
                            label='Data Cadastro' placeholder='Informe a Agência'
                            readOnly={true}
                            format={formatData} />

                        <Field name='dt_vencimento' component={labelAndInput}
                            label='Data Vencimento'
                            cols='12 2'
                            type='date'
                            readOnly={false}
                            format={formatData2} />
                        <Field name='valor' component={labelAndInput}
                            label='Valor'
                            cols='12 2'
                            type='numeric'
                            readOnly={this.props.isRegistred}
                            format={currencyFormatter} />

                        <Field name='descricao' component={textArea}
                            cols='12 12'
                            type="textare"
                            label='Descrição'
                            readOnly={this.props.isRegistred} />

                        <Field name='nome_cliente' component={labelAndInput}
                            cols='12 6'
                            label='Nome Cliente'
                            readOnly={this.props.isRegistred} />

                        {/* final da primeira linha */}

                        <Field name='cpf_cnpj_cliente' component={labelAndInput}
                            label='CPF'
                            cols='12 2'
                            readOnly={this.props.isRegistred} />

                        <Field name='endereco' component={labelAndInput}
                            type='text' cols='12 4'
                            label='Endereço'
                            readOnly={this.props.isRegistred} />

                        <Field name='municipio' component={labelAndInput}
                            type='text' cols='12 3'
                            label='Município'
                            readOnly={this.props.isRegistred} />

                        <Field name='cep' component={labelAndInput}
                            type='text' cols='12 2'
                            label='CEP'
                            readOnly={this.props.isRegistred} />

                        <Field name='uf' component={labelAndInput}
                            type='text' cols='12 1'
                            label='Uf'
                            readOnly={this.props.isRegistred}
                        />

                        {/* final da segunda linha */}


                        <Field name='tipo_desconto' component={Select}
                            cols='12 4'
                            label='Tipo Desconto (Válido até a Data de Venc.)'
                            lista={this.getListaTipoDesconto()}
                            onChange={this.handleChange}
                            readOnly={true}
                            disabled={true} />
                        <Field name='valor_desconto' component={labelAndInput}
                            type='numeric' cols='12 2'
                            label='Valor Desconto'
                            placeholder='Valor Desconto'
                            className='valor_monetario form-control'
                            pattern="[0-9]*"
                            inputMode="numeric"
                            {...currencyMask}
                            readOnly={true} />

                        <Field name='percentual_desconto' component={labelAndInput}
                            type='numeric' cols='12 2'
                            label='Percentual Desconto'
                            placeholder='Percentual Desconto'
                            className='valor_monetario form-control'
                            pattern="[0-9]*"
                            inputMode="numeric"
                            {...currencyMask}
                            readOnly={true} />



<Field name='tipo_multa' component={Select}
                            cols='12 2'
                            label='Tipo Multa'
                            lista={this.getListaTipoMulta()}
                            readOnly={true}
                            disabled={true} />
                        <Field name='valor_multa' component={labelAndInput}
                            type='numeric' cols='12 2'
                            label='Valor Multa'
                            placeholder='Valor Multa'
                            className='valor_monetario form-control'
                            pattern="[0-9]*"
                            inputMode="numeric"
                            {...currencyMask}
                            readOnly={true} />

                        <Field name='percentual_multa' component={labelAndInput}
                            type='numeric' cols='12 2'
                            label='Percentual Multa'
                            placeholder='Percentual Multa'
                            className='valor_monetario form-control'
                            pattern="[0-9]*"
                            inputMode="numeric"
                            {...currencyMask}
                            readOnly={true} />


<Field name='tipo_juro' component={Select}
                            cols='12 2'
                            label='Tipo Juros'
                            lista={this.getListaTipoJuro()}
                            readOnly={true}
                            disabled={true} />
                        <Field name='valor_juro' component={labelAndInput}
                            type='numeric' cols='12 2'
                            label='Valor Juros'
                            placeholder='Valor Juros'
                            className='valor_monetario form-control'
                            pattern="[0-9]*"
                            inputMode="numeric"
                            {...currencyMask}
                            readOnly={true} />

                        <Field name='percentual_juro' component={labelAndInput}
                            type='numeric' cols='12 2'
                            label='Percentual Juros'
                            placeholder='Percentual Juros'
                            className='valor_monetario form-control'
                            pattern="[0-9]*"
                            inputMode="numeric"
                            {...currencyMask}
                            readOnly={true} />



                        <Field name='usuario_cadsatro.nome' component={labelAndInput}
                            type='text' cols='12 3'
                            label='Usuário de Cadastro'
                            readOnly={true} />

                        <Field name='usuario_cancelamento.nome' component={labelAndInput}
                            type='text' cols='12 3'
                            label='Usuário Cancelamento'
                            readOnly={true} />


                    </div>
                    <div className="boxfooter">
                        <button type='submit'
                            className={`btn btn-${this.props.submitClass}`}>
                            <i className={`fa fa-${this.props.iconSubmit}`}></i>
                            <span className='space-icon'>{this.props.submitLabel}</span>
                        </button>
                        <button type='button' className="btn btn-default"
                            onClick={this.props.init} ><i className="fa fa-ban"></i><span className='space-icon'>Cancelar</span></button>
                    </div>
                </form>
            </div>
        )
    }
}

BoletoForm = reduxForm({ form: 'boletoForm', destroyOnUnmount: false })(BoletoForm)
const selector = formValueSelector('boletoForm')
const mapStateToProps = state => ({
    boleto: state.boleto,
    isRegistred: selector(state, 'is_registrado'),
    usuario_cancelamento: selector(state, 'usuario_cancelamento'),
    usuario_cadsatro: selector(state, 'usuario_cadsatro'),
})
const mapDispatchToProps = dispatch => bindActionCreators({ init }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(BoletoForm)



// WEBPACK FOOTER //
// ./src/boleto/boletoForm.jsx